var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nav-tabs" },
    [
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hidden,
              expression: "!hidden",
            },
          ],
          staticClass: "nav-list",
          class: { "bottom-indent": _vm.tabTitles.length },
        },
        _vm._l(_vm.tabTitles, function (title, index) {
          return _c(
            "li",
            {
              key: index,
              class: _vm.subTabs ? "sub-nav-item" : "nav-item",
              attrs: { id: `tab-${index}` },
              on: {
                click: function ($event) {
                  return _vm.changeSelectedTitle(title, index)
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "nav-link",
                  class: { active: _vm.selectedTitle === title },
                },
                [_vm._v("\n        " + _vm._s(title) + "\n      ")]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm._t("hint"),
      _vm._v(" "),
      _vm._t("top"),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }